let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hAiso")).then(() => parcelRequire('h9Zp1'));